import { useSearch, Link } from '@tanstack/react-router';
import useAzureCallback from 'src/api/oauth/azure/useAzureCallback';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import MDButton from 'src/components/md/MDButton';
import CircularProgress from '@mui/material/CircularProgress';
import useTestEmailApi from 'src/api/oauth/azure/useTestEmailApi';

const AzureOauthFlowCallback = () => {
  const search = useSearch({ strict: false });
  const { code, error, error_description: errorDescription } = search;
  const { mutate: testEmailApi } = useTestEmailApi();

  const { isLoading, error: callbackError } = useAzureCallback(code);

  // TODO remove this
  // eslint-disable-next-line
  (window as unknown as any).testEmailAPI = testEmailApi;

  const renderContent = () => {
    // Handle OAuth error response
    if (error) {
      return (
        <>
          <Icon sx={{ fontSize: 56, color: 'error.main', mb: 2 }}>error</Icon>
          <MDTypography variant="h4" color="error" mb={2}>
            Authentication Failed
          </MDTypography>
          <MDTypography variant="body2" color="text" mb={3}>
            {errorDescription ||
              'There was an error connecting to Microsoft Outlook.'}
          </MDTypography>
        </>
      );
    }

    // Handle API error
    if (callbackError) {
      return (
        <>
          <Icon sx={{ fontSize: 56, color: 'error.main', mb: 2 }}>error</Icon>
          <MDTypography variant="h4" color="error" mb={2}>
            Connection Failed
          </MDTypography>
          <MDTypography variant="body2" color="text" mb={3}>
            We encountered an error while setting up your Outlook connection.
            Please try again.
          </MDTypography>
        </>
      );
    }

    // Handle loading state
    if (isLoading) {
      return (
        <>
          <CircularProgress size={56} sx={{ mb: 2 }} />
          <MDTypography variant="h4" mb={2}>
            Connecting...
          </MDTypography>
          <MDTypography variant="body2" color="text" mb={3}>
            Please wait while we complete your Outlook connection.
          </MDTypography>
        </>
      );
    }

    // Handle success state
    return (
      <>
        <Icon sx={{ fontSize: 56, color: 'success.main', mb: 2 }}>
          check_circle
        </Icon>
        <MDTypography variant="h4" color="success" mb={2}>
          Successfully Connected!
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={3}>
          Your Microsoft Outlook account has been successfully connected.
        </MDTypography>
      </>
    );
  };

  return (
    <MDBox
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'grey.100',
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', m: 2 }}>
        <MDBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            p: 4,
          }}
        >
          {renderContent()}
          <MDButton
            component={Link}
            to="/settings/organization?section=accounts"
            variant="gradient"
            color="info"
          >
            Return to Settings
          </MDButton>
        </MDBox>
      </Card>
    </MDBox>
  );
};

export default AzureOauthFlowCallback;
